export const RESERVATION_CREATED = 'reservation_created';
export const RESERVATION_CANCELLED = 'reservation_cancelled';
export const RESERVATION_CONFIRMED = 'reservation_confirmed';
export const RESERVATION_REJECTED = 'reservation_rejected';